import { RootState } from "../../../../../store";
import { filterChangedByKeySelector } from "../filterChangedByKeySelector";
import { resourceExplorerIdSelector } from "../../../current-resource-explorer/resourceExplorerIdSelector";
import { resourceExplorerProvidersSelector } from "../../../current-resource-explorer/resourceExplorerProvidersSelector";

export const accountFilterChangedSelector = (state: RootState) => {
  const viewId = resourceExplorerIdSelector(state);
  const providers = resourceExplorerProvidersSelector(state);

  return providers.reduce((result, provider) => {
    const isChanged = filterChangedByKeySelector(state, {
      viewId,
      key: "account",
      provider,
    });
    if (isChanged) {
      result = true;
    }

    return result;
  }, false);
};
